import React from 'react';
import { useAdmin } from '../../context/AdminContext';
import { TrendingUp, ShoppingBag, Users, ArrowDownToLine, Package, Clock } from 'lucide-react';

const Card = ({ label, value, icon: Icon, accent = '#22c55e' }) => (
  <div className="border border-[#151515] bg-[#0a0a0a] rounded-md p-5 font-mono relative overflow-hidden">
    <div className="flex items-center justify-between">
      <div className="text-[10px] tracking-[0.25em] text-[#5a5a5a]">{label}</div>
      <Icon size={16} style={{ color: accent }} />
    </div>
    <div className="mt-3 text-2xl text-[#e6e6e6]">{value}</div>
  </div>
);

const Dashboard = () => {
  const { stats, orders, deposits } = useAdmin();

  if (!stats) return <div className="p-8 text-[#7a7a7a] font-mono text-sm">Loading dashboard…</div>;

  const pendingOrders = orders.filter((o) => o.status === 'PENDING');
  const pendingDeposits = deposits.filter((d) => d.status === 'PENDING');

  return (
    <div className="px-8 py-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <div className="text-[10px] tracking-[0.25em] text-[#5a5a5a] font-mono">OVERVIEW</div>
          <div className="text-2xl text-[#e6e6e6] font-mono">Dashboard</div>
        </div>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <Card label="REVENUE (USDT)" value={`$${stats.revenue_usdt.toFixed(2)}`} icon={TrendingUp} />
        <Card label="REVENUE (INR)" value={`₹${stats.revenue_inr.toFixed(2)}`} icon={TrendingUp} />
        <Card label="TOTAL ORDERS" value={stats.orders_total} icon={ShoppingBag} />
        <Card label="TOTAL USERS" value={stats.users_total} icon={Users} />
        <Card label="PENDING ORDERS" value={stats.orders_pending} icon={Clock} accent="#f59e0b" />
        <Card label="DELIVERED" value={stats.orders_delivered} icon={Package} />
        <Card label="PENDING DEPOSITS" value={stats.deposits_pending} icon={ArrowDownToLine} accent="#f59e0b" />
        <Card label="AVG STATUS" value={stats.orders_pending > 0 ? 'ACTION' : 'CLEAR'} icon={Clock} accent={stats.orders_pending > 0 ? '#ef4444' : '#22c55e'} />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div className="border border-[#151515] bg-[#0a0a0a] rounded-md p-5 font-mono">
          <div className="text-[10px] tracking-[0.25em] text-[#5a5a5a] mb-3">TOP PRODUCTS</div>
          {stats.top_products.length === 0 ? (
            <div className="text-[12px] text-[#5a5a5a]">No sales yet.</div>
          ) : stats.top_products.map((p, i) => (
            <div key={p.product_id} className="flex items-center justify-between py-2 border-b border-[#0f0f0f] last:border-0">
              <span className="text-[12px] text-[#e6e6e6]"><span className="text-[#5a5a5a] mr-2">#{i+1}</span>{p.name}</span>
              <span className="text-[12px] text-[#22c55e]">{p.count} sold</span>
            </div>
          ))}
        </div>

        <div className="border border-[#151515] bg-[#0a0a0a] rounded-md p-5 font-mono">
          <div className="text-[10px] tracking-[0.25em] text-[#5a5a5a] mb-3">ACTION QUEUE</div>
          <div className="flex items-center justify-between py-2 border-b border-[#0f0f0f]">
            <span className="text-[12px] text-[#e6e6e6]">Pending Orders</span>
            <span className={`text-[12px] ${pendingOrders.length > 0 ? 'text-[#f59e0b]' : 'text-[#5a5a5a]'}`}>{pendingOrders.length}</span>
          </div>
          <div className="flex items-center justify-between py-2 border-b border-[#0f0f0f]">
            <span className="text-[12px] text-[#e6e6e6]">Pending Deposits</span>
            <span className={`text-[12px] ${pendingDeposits.length > 0 ? 'text-[#f59e0b]' : 'text-[#5a5a5a]'}`}>{pendingDeposits.length}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
